import { fetchStocks } from "./inventoryAction";
import { formatData } from "./utils";

export function fetchInstalls(){
    console.log("FIRED ACTION FETCH INSTALLS" )
    return async function(dispatch){
        dispatch({
            type: "FETCH_INSTALLS_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/getList',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"installs",
                }),
                credentials: 'same-origin',
            }); 
            
            const installsList = await response.json()
            console.log(installsList)// installsList returns new object created

            if(!installsList.error){ // no errors, return new Object
                
                dispatch( getInstalls(formatData(installsList.reverse())) )
                dispatch({ type: "FETCH_INSTALLS_FULFILLED", payload:"" })
                console.log("installs fetched")
                
                // dispatch(fetchStocks())
            
            } else {
                dispatch({
                    type: "FETCH_INSTALLS_ERROR",
                    payload: installsList.error.message
                })
            }
            
        } catch (err) {
            dispatch({
                type: "FETCH_INSTALLS_ERROR",
                payload: err
                
            })
        }
    }
}
export function createInstall(newInstall, page = "installs"){
    console.log("FIRED ACTION CREATE INSTALL", newInstall)
    return async function(dispatch){
        dispatch({
            type: "CREATE_INSTALL_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page,
                    data:newInstall
                }),
                credentials: 'same-origin',
            }); 
            
            const createdInstall = await response.json()
            console.log(createdInstall)// createdInstall returns new object created

            if(createdInstall.id){ // no errors, return new Object
                newInstall.client.id = createdInstall.client_ref
                dispatch({
                    type:"NEW_CLIENT",
                    payload: newInstall.client
                })
                dispatch({
                    type:"NEW_INSTALL",
                    payload: createdInstall
                })
                dispatch({ type: "CREATE_INSTALL_FULFILLED", payload:"" })
                console.log(page ," created")
                
                dispatch(fetchStocks())
            } else {
                dispatch({
                    type: "CREATE_INSTALL_ERROR",
                    payload: createdInstall.error.message
                })
            }
            
        } catch (err) {
            console.log('====================================');
            console.log("error create install", err);
            console.log('====================================');
            dispatch({
                type: "CREATE_INSTALL_ERROR",
                payload: err
                
            })
        }
    }
}
export function createSaleFromInstall(newInstall, page = "installs/sale/new"){
    console.log("FIRED ACTION CREATE INSTALL", newInstall)
    return async function(dispatch){
        dispatch({
            type: "CREATE_SALE_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page,
                    data: newInstall
                }),
                credentials: 'same-origin',
            }); 
            
            const createdSale = await response.json()
            console.log(createdSale)// createdSale returns new object created

            if(createdSale.id){ // no errors, return new Object
                dispatch({
                    type:"NEW_SALE",
                    payload: createdSale
                })
                dispatch({ type: "CREATE_SALE_FULFILLED", payload:"" })
                console.log(page ," created")
                
                dispatch(fetchStocks())

                // update install status 
               dispatch({ type: "DELETE_INSTALL", payload: newInstall.id })

            
            } else {
                dispatch({
                    type: "CREATE_SALE_ERROR",
                    payload: createdSale.error.message
                })
            }
            
        } catch (err) {
            console.log('====================================');
            console.log("error create install", err);
            console.log('====================================');
            dispatch({
                type: "CREATE_SALE_ERROR",
                payload: err
                
            })
        }
    }
}

export function deleteInstall(install){
    return async function(dispatch){
        dispatch({ type: "DELETE_INSTALL_START", payload: "" })
        try {
            const response = await fetch('/stocks/delete',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    type:"install",
                    data:install
                }),
                credentials: 'same-origin',
            }); 
            const body = await response.json()
            console.log("DELETE INSTALL RESPONSE",{body})

            if(!body.error){ // no errors, return new Object
                dispatch({ type: "DELETE_INSTALL", payload: install.id })
                dispatch({ type: "DELETE_INSTALL_FULFILLED", payload:"" })
                dispatch(fetchStocks())
                return "OK"
            } else {
                dispatch({
                    type: "DELETE_INSTALL_ERROR",
                    payload: body.error.message
                })
            }
            throw new Error(body.error.message)
        } catch (err) {
            dispatch({  type: "DELETE_INSTALL_ERROR", payload: err })
            throw err
        }
    }
}
export function getInstalls(installs){
    
    return {
        type: "GET_INSTALLS",
        payload: installs
    }
}


export function getInstall(install_Id){
    // console.log("FIRED ACTION GET INSTALLS", installs)
    return {
        type: "GET_INSTALL",
        payload: install_Id
        
    }
}